import { render } from "./ButtonInputStyleProvider.vue?vue&type=template&id=4db05f61&scoped=true&lang=pug"
import script from "./ButtonInputStyleProvider.vue?vue&type=script&lang=ts"
export * from "./ButtonInputStyleProvider.vue?vue&type=script&lang=ts"

import "./ButtonInputStyleProvider.vue?vue&type=style&index=0&id=4db05f61&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4db05f61"

export default script